import produce from 'immer';

import { FETCH_FAVORITE_DRAMAS_SUCCEEDED, LOGOUT } from '../../constants/actionTypes';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_FAVORITE_DRAMAS_SUCCEEDED: {
      return action.payload.entities.favoriteDramas;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
